import { useMutation } from '@tanstack/react-query';
import type { ApiResponse } from '@/lib/api';
import { apiRequest } from '@/lib/api-utils';
import { API_ENDPOINTS } from '@/lib/constants';
import type { AIGeneratedCommunicationData } from '../types';

export type ImageStyle =
  | 'illustration'
  | 'photorealistic'
  | 'graphic_design'
  | 'cartoon'
  | 'minimalist'
  | 'watercolor';

export interface GeneratePartnerEmailRequest {
  userPrompt: string;
  imageStyle?: ImageStyle;
}

async function generatePartnerEmail(
  payload: GeneratePartnerEmailRequest,
): Promise<AIGeneratedCommunicationData> {
  const response = await apiRequest<ApiResponse<AIGeneratedCommunicationData>>(
    API_ENDPOINTS.PARTNER.AI_AUTOMATION_GENERATE_CONTENT,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );

  return response.data;
}

export function useGeneratePartnerEmail() {
  return useMutation({
    mutationFn: generatePartnerEmail,
  });
}
